import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MyUtil from '../../functions/MyUtil';
import CustomerDetail from './CustomerDetail';
import ListCustomer from './ListCustomer';

const Customer = (props) => {
  const { match } = props;
  return (
    <div>
      <Switch>
        {MyUtil.hasPermission(match.url, 'view') && (
          <Route
            exact
            path={`${match.url}`}
            component={() => <ListCustomer match_parent={match} />}
          />
        )}
        {MyUtil.hasPermission(match.url, 'update') && (
          <Route
            path={`${match.url}/detail/:customerId`}
            component={CustomerDetail}
          />
        )}
      </Switch>
    </div>
  );
};

export default Customer;
